const themeLightNotificationErrorSoft = '#FFE2E4';

export { themeLightNotificationErrorSoft };
